var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { route } from '../paths';
import { getValue } from '../selectors';
export var createDraftAddress = function (address) { return (__assign({}, address)); };
export var createDraftRoute = function (count, route) {
    if (route && route.length > 0) {
        return route.map(createDraftAddress);
    }
    return __spreadArray([], Array(count)).map(createDraftAddress);
};
export var getDraftRoute = function (state) { return getValue(route, state); };
